/* Fashion Drinks Advent 2026. Uses native Shopify product forms; owns no cart. */
(() => {
  'use strict';
  if (window.FDAdvent2026) {
    window.FDAdvent2026.init(document);
    return;
  }
  const cleanups = new WeakMap();
  const sessionKey = 'fd-advent-2026-popup-seen';
  let popupSeenHere = false;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const visible = element => element && !element.hidden && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const seen = () => {
    if (popupSeenHere) return true;
    try { return sessionStorage.getItem(sessionKey) === '1'; } catch { return false; }
  };
  const remember = () => {
    popupSeenHere = true;
    try { sessionStorage.setItem(sessionKey, '1'); } catch { /* A blocked store cannot break navigation. */ }
  };

  function initializeSection(root) {
    if (root.dataset.fdAdventReady) return;
    root.dataset.fdAdventReady = 'true';
    const controller = new AbortController();
    const on = (element, type, listener, options = {}) => element?.addEventListener(type, listener, { ...options, signal: controller.signal });
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const gallery = $('[data-mcal-gallery]');
    const mainImage = $('[data-mcal-main-image]');
    const mainVideo = $('[data-mcal-main-video]');
    const photoExpand = $('[data-mcal-photo-expand]');
    const thumbs = $$('[data-fd-gallery-image]');
    const photoDialog = $('[data-mcal-photo-dialog]');
    let galleryIndex = Math.max(0, thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    let previousPhotoFocus;

    const selectImage = (index, scrollThumb = false) => {
      if (!thumbs.length || !mainImage) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      const selected = thumbs[galleryIndex];
      const isVideo = selected.dataset.mediaType === 'video';
      if (mainVideo) { mainVideo.pause(); mainVideo.hidden = !isVideo; }
      mainImage.hidden = isVideo;
      if (photoExpand) photoExpand.hidden = isVideo;
      if (!isVideo) {
        mainImage.src = selected.dataset.src;
        mainImage.removeAttribute('srcset');
        mainImage.alt = selected.dataset.alt || '';
      }
      if (Number(selected.dataset.aspect) > 0) gallery.style.aspectRatio = selected.dataset.aspect;
      if (Number(selected.dataset.width) > 0) mainImage.width = Number(selected.dataset.width);
      if (Number(selected.dataset.height) > 0) mainImage.height = Number(selected.dataset.height);
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      const caption = $('[data-mcal-image-caption]');
      if (caption) caption.textContent = selected.dataset.alt || '';
      if (scrollThumb) selected.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion() ? 'auto' : 'smooth' });
    };
    thumbs.forEach((button, index) => on(button, 'click', () => selectImage(index)));
    on(gallery, 'keydown', event => {
      if (event.target !== gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      selectImage(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    let pointerStart;
    let suppressGalleryClick = false;
    on(gallery, 'pointerdown', event => {
      if (event.target.closest('video')) return;
      suppressGalleryClick = false;
      if (event.isPrimary && event.button === 0) pointerStart = { x: event.clientX, y: event.clientY };
    });
    on(gallery, 'pointerup', event => {
      if (!pointerStart) return;
      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        suppressGalleryClick = true;
        selectImage(galleryIndex + (dx < 0 ? 1 : -1), true);
      }
    });
    on(gallery, 'pointercancel', () => { pointerStart = null; });
    const openPhoto = () => {
      if (thumbs[galleryIndex]?.dataset.mediaType === 'video') return;
      if (!photoDialog || typeof photoDialog.showModal !== 'function' || !mainImage) return;
      previousPhotoFocus = document.activeElement;
      const image = photoDialog.querySelector('img');
      image.src = thumbs[galleryIndex]?.dataset.full || mainImage.src;
      image.alt = mainImage.alt;
      photoDialog.showModal();
    };
    on($('[data-mcal-photo-expand]'), 'click', openPhoto);
    on(mainImage, 'click', event => {
      if (suppressGalleryClick) { suppressGalleryClick = false; return; }
      if (event.detail && !pointerStart) openPhoto();
    });
    on($('[data-mcal-close]'), 'click', () => photoDialog?.close());
    on(photoDialog, 'click', event => {
      if (event.target !== photoDialog) return;
      const rect = photoDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) photoDialog.close();
    });
    on(photoDialog, 'close', () => { if (previousPhotoFocus?.isConnected) previousPhotoFocus.focus({ preventScroll: true }); });

    $$('[data-mcal-box-view]').forEach(button => on(button, 'click', () => {
      const image = $('[data-mcal-box-image]');
      if (!image || !button.dataset.fdBoxSrc) return;
      image.src = button.dataset.fdBoxSrc;
      image.removeAttribute('srcset');
      image.alt = button.dataset.mcalBoxView === 'back' ? 'Rückseite der Kalenderbox mit Kaminmotiv' : 'Vorderseite der Kalenderbox mit Weihnachtsbaum';
      $$('[data-mcal-box-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));

    const form = $('.fd-advent-native-form');
    if (form) {
      const quantity = form.querySelector('[name="quantity"]');
      const add = form.querySelector('[data-fd-advent-add]');
      const status = form.querySelector('[data-fd-advent-status]');
      const variantInputs = [...form.querySelectorAll('[data-fd-advent-variant]')];
      const currentVariant = () => variantInputs.find(input => input.checked);
      const purchaseReady = input => Boolean(input && root.dataset.purchaseEnabled === 'true' && input.dataset.available === 'true' && Number(input.dataset.price) > 0);
      const updateVariant = (updateUrl = false) => {
        const input = currentVariant();
        if (!input) { add.disabled = true; return; }
        const price = $('[data-fd-advent-price]');
        const priceNote = $('[data-fd-advent-price-note]');
        const priced = Number(input.dataset.price) > 0;
        price.textContent = priced ? input.dataset.priceLabel : 'Verkaufspreis folgt';
        price.classList.toggle('mcal-pending-price', !priced);
        priceNote.textContent = priced ? (root.dataset.taxesIncluded === 'true' ? 'inkl. MwSt.' : 'zzgl. MwSt.') : 'Edition 2026';
        add.disabled = !purchaseReady(input);
        add.textContent = purchaseReady(input) ? 'In den Warenkorb' : !priced ? 'Verkaufspreis folgt' : input.dataset.available !== 'true' ? 'Aktuell nicht verfügbar' : 'Noch nicht bestellbar';
        quantity.min = input.dataset.min || '1';
        quantity.step = input.dataset.step || '1';
        if (input.dataset.max) quantity.max = input.dataset.max;
        else quantity.removeAttribute('max');
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
        if (quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
        const imageIndex = thumbs.findIndex(button => button.dataset.imageId === input.dataset.imageId);
        if (input.dataset.imageId && imageIndex >= 0) selectImage(imageIndex);
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        }
        status.textContent = '';
      };
      variantInputs.forEach(input => on(input, 'change', () => updateVariant(true)));
      form.querySelectorAll('[data-mcal-quantity]').forEach(button => on(button, 'click', () => {
        const step = Number(quantity.step) || 1;
        const min = Number(quantity.min) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        quantity.value = String(Math.min(max, Math.max(min, (Number(quantity.value) || min) + Number(button.dataset.mcalQuantity) * step)));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      on(form, 'submit', event => {
        if (!purchaseReady(currentVariant())) {
          event.preventDefault();
          status.textContent = 'Diese Variante ist derzeit nicht bestellbar.';
        }
        // A valid native Shopify form continues normally to /cart/add.
      });
      updateVariant();
    }

    let revealObserver;
    if (!reduceMotion() && 'IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('mcal-show-on-scroll'); revealObserver.unobserve(entry.target); }
      }), { threshold: 0.08 });
      $$('[data-mcal-reveal]').forEach(element => revealObserver.observe(element));
    }
    cleanups.set(root, () => { controller.abort(); revealObserver?.disconnect(); if (photoDialog?.open) photoDialog.close(); });
  }

  function initializePopup(host) {
    if (host.dataset.fdAdventReady) return;
    host.dataset.fdAdventReady = 'true';
    const dialog = host.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const controller = new AbortController();
    const on = (element, type, listener) => element?.addEventListener(type, listener, { signal: controller.signal });
    const editorPreview = Boolean(window.Shopify?.designMode && host.dataset.preview === 'true');
    let timer;
    let retries = 0;
    let previousFocus;
    const busy = () => {
      if (document.hidden || document.querySelector('dialog[open]')) return true;
      if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
      return [...document.querySelectorAll('[aria-modal="true"],.drawer.is-open,.drawer--is-open,.mobile-nav--open,[data-search-open="true"],header [aria-expanded="true"]')].some(element => element !== dialog && visible(element));
    };
    const open = (manual = false) => {
      clearTimeout(timer);
      if (dialog.open || (!editorPreview && seen())) return;
      if (!manual && busy()) { if (retries++ < 30) timer = setTimeout(() => open(), 2000); return; }
      previousFocus = document.activeElement;
      try { dialog.showModal(); } catch { return; }
      document.body.classList.add('fd-advent-campaign-open');
      if (!editorPreview) remember();
    };
    host.querySelectorAll('[data-fd-popup-close]').forEach(button => on(button, 'click', () => dialog.close()));
    on(host.querySelector('[data-fd-popup-launch]'), 'click', () => open(true));
    on(dialog.querySelector('a'), 'click', () => { if (!editorPreview) remember(); dialog.close(); });
    on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    on(dialog, 'close', () => {
      document.body.classList.remove('fd-advent-campaign-open');
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    // Native <dialog> supplies focus trapping and Escape handling.
    const destination = new URL(host.dataset.destination, location.origin);
    const alreadyExploring = destination.pathname.replace(/\/+$/, '') === location.pathname.replace(/\/+$/, '') || document.querySelector('[data-fd-advent]');
    if (editorPreview) timer = setTimeout(() => open(), 400);
    else if (host.dataset.enabled === 'true' && !alreadyExploring && !seen()) timer = setTimeout(() => open(), Math.max(5, Number(host.dataset.delay) || 9) * 1000);
    cleanups.set(host, () => {
      clearTimeout(timer);
      if (dialog.open) dialog.close();
      // close is asynchronous; section removal must release scrolling immediately.
      document.body.classList.remove('fd-advent-campaign-open');
      controller.abort();
    });
  }

  function init(container) {
    if (container.matches?.('[data-fd-advent]')) initializeSection(container);
    if (container.matches?.('[data-fd-advent-popup]')) initializePopup(container);
    container.querySelectorAll?.('[data-fd-advent]').forEach(initializeSection);
    container.querySelectorAll?.('[data-fd-advent-popup]').forEach(initializePopup);
  }
  window.FDAdvent2026 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-fd-advent],[data-fd-advent-popup]').forEach(element => cleanups.get(element)?.());
  });
  document.addEventListener('shopify:block:select', event => { const details = event.target.closest('details'); if (details) details.open = true; });
})();
